export const STATES = {
  ON_HAND: "on-hand"
};

export const OPTION_FROM_CONFIG = "option-from-config";

export const UPDATE_STATE_MAX_RETRY_COUNT = 3;
export const UPDATE_STATE_BATCH_SIZE = 15;
